import { useNavigate, useOutletContext } from 'react-router-dom';
import { ScheduleDemo, SignupError } from '../../components/signup';
import { SignupOutletContext } from '../../components/signup/types';
import * as Sentry from '@sentry/react';
import { useFeatureFlags } from '../../hooks/useFeatureFlags';
import { useFlowType } from '../../hooks/useFlowType';
import { LoadingSpinner } from 'design-system/src/components/LoadingSpinner/LoadingSpinner';
import { SignupType, canSetUpAccount } from '../../components/signup/utils';

const ScheduleDemoPage = () => {
  const navigate = useNavigate();
  const signupType = localStorage.getItem('signupType') || 'null';
  const signupId = localStorage.getItem('signupId');
  const { formState } = useOutletContext<SignupOutletContext>();
  const { data: featureFlags, isLoading: isLoadingFeatureFlags } = useFeatureFlags();
  const flowType = useFlowType();

  const handleNext = () => {
    const basePath = `/${flowType}`;
    navigate(`${basePath}/confirmation-step`);
  };

  const handleSkip = () => {
    navigate('/signup/verification-email', { replace: true });
  };

  if (!signupType) {
    Sentry.captureException('[ScheduleDemoPage] No signup type found in local storage');
    return <SignupError />;
  }

  if (isLoadingFeatureFlags) {
    return <LoadingSpinner />;
  }

  return (
    <ScheduleDemo
      onNext={handleNext}
      onSkip={handleSkip}
      signupType={signupType as SignupType}
      signupId={signupId || ''}
      formState={formState}
      canSetUpAccount={canSetUpAccount(featureFlags, signupType as SignupType, formState.specialty)}
    />
  );
};

export default ScheduleDemoPage;
